// Create or edit field dialog

import { PMButton } from "../../utils/PMButton";
import { PMDialog } from "../../utils/PMDialog";
import { PMField } from "../../utils/PMField";
import { PMForm } from "../../utils/PMForm";
import * as Yup from "yup";

export const FieldDialog = (props) => {
  const { module, moduleParam, selected, updateFunction, createFunction } =
    props;

  const initialValues = {
    id: selected?.id || null,
    module: module,
    module_param: moduleParam,
  };

  const requiredFields = [
    {
      field: "name",
      validation: Yup.string().required("Name is required"),
    },
    // {
    //   field: "description",
    //   validation: Yup.string().required("Description is required"),
    // },
  ];

  const FormContent = (formik) => {
    return (
      <div>
        <div>
          <PMField name="name" label="Name" {...formik} />
        </div>

        <div>
          <PMButton type="buton" onClick={() => formik.submitForm()}>
            Lagre
          </PMButton>
        </div>
      </div>
    );
  };

  return (
    <PMDialog open={props.open} onClose={props.onClose} title={props.title}>
      <PMForm
        id={selected?.id}
        initialValues={initialValues}
        requiredFields={requiredFields}
        content={FormContent}
      />
    </PMDialog>
  );
};
